import { __awaiter, __generator } from "tslib";
export var LOADABLE_COMPONENTS_MAP = {
    Header: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "Header" */
                './modules/_core/components/Header/Header')];
        });
    }); },
    TextMessage: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "TextMessage" */
                './modules/chat/components/Messages/TextMessage')];
        });
    }); },
    CarouselWidget: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "CarouselWidget" */
                './modules/chat/components/CarouselWidget/CarouselWidget')];
        });
    }); },
    GenericFormWidget: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "GenericFormWidget" */
                './modules/chat/components/GenericFormWidget/GenericFormWidget')];
        });
    }); },
    NotificationWidget: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "NotificationWidget" */
                './modules/chat/components/NotificationWidget/NotificationWidget')];
        });
    }); },
    TilesWidget: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "TilesWidget" */
                './modules/chat/components/TilesWidget/TilesWidget')];
        });
    }); },
    NewConversationWidget: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, import(
                /* webpackPrefetch: true, webpackChunkName: "NewConversationWidget" */
                './modules/chat/components/NewConversationWidget/NewConversationWidget')];
        });
    }); },
};
